import {loadGroupItems} from "../../ReduxStore/ProductGroupPage/groupItemsSlice";
import {safeGtag} from "../../Analytics/googleAnalyticsFour";
import {pushUrlState, editUrlParams} from "../../Utility/urls";
import {parsePageType} from "./productGroup";

/**
 * 2026-07 simplify props, remove legacy GroupPageType object
 */
export default class VehicleChangeHandler {
  constructor({productGroup, changes, customerVehicle, watchedFields}) {
    this.productGroup = productGroup;
    this.changes = changes || {};
    this.customerVehicle = customerVehicle;

    let pt = parsePageType(productGroup.pageType);
    this.watchedFields = watchedFields || pt.watchedFields;
  }

  call({dispatch}) {
    this.onBaseVehicleChange({dispatch});

    // console.error("---------- Vehicle change handler - changes are ", this.changes);

    if (canLoadProducts(this.watchedFields, this.customerVehicle)) {
      // console.log("LOAD PRODS ")
      this.loadProducts({dispatch})
    }
  }

  onBaseVehicleChange({dispatch}) {
    let change = this.changes['id'];
    if (!change) return null;

    return change[1] ? this.onSetVehicle() : this.onClearVehicle();
  }

  onSetVehicle() {
    let cv = this.customerVehicle;
    // console.log("ON SET VEHICLE", this.changes, this.customerVehicle);

    // 2022-06 do not redirect to ?set-vehicle=1 on initial load.
    if (cv && (cv.source == 'initial')) {
      return;
    }

    return this.rewriteLocation({'set-vehicle': 1, 'clear-vehicle': null})
  }

  onClearVehicle() {
    // this.customerVehicle is null already, nothing to extract from it
    safeGtag('event', 'clear_vehicle', {});

    return this.rewriteLocation({'set-vehicle': null, 'clear-vehicle': 1})
  }

  rewriteLocation(edits) {
    let url = editUrlParams(globalThis.location, edits);

    pushUrlState(url);
  }

  loadProducts({dispatch}) {
    const {customerVehicle, watchedFields, productGroup} = this;

    let params = {group_id: productGroup.id};
    for (let k of watchedFields) {
      let f = (k === 'id') ? 'vehicle_id' : k;
      params[f] = customerVehicle[k];
    }

    dispatch(loadGroupItems({params}));
  }


}

function canLoadProducts(watchedFields, customerVehicle = {}) {
  if (!customerVehicle) return false;

  for (let k of watchedFields) {
    if (!customerVehicle[k])
      return false;
  }

  return true;
}
